//API进行统一管理
import requests from './axios';

//首页banner 
export const reqBanner=()=>requests({url:'/banner',method:'POST'})
//首页手风琴
export const Banner1=(params)=>requests({url:'/banner1',method:'POST',data:params})   
//公司概况type类型 1、企业介绍 2、管理体系 3、组织构架 5、业务内容基本信息
export const About=(params)=>requests({url:'/about',method:'POST',data:params})
//新闻列表
export const News=(params)=>requests({url:'/news',method:'POST',data:params})
//新闻列表-详情
export const NewsInfo=(params)=>requests({url:'/newsInfo',method:'POST',data:params})
//典型案例
export const Cate=(params)=>requests({url:'/cate',method:'POST',data:params})
//典型列表
export const Cases=(params)=>requests({url:'/cases',method:'POST',data:params})
//典型列表-详情
export const CasesInfo=(params)=>requests({url:'/casesInfo',method:'POST',data:params})
//装置列表
export const CaseTp=(params)=>requests({url:'/caseTp',method:'POST',data:params})
//典型案例主要业绩
export const CaseOther=(params)=>requests({url:'/caseOther',method:'POST',data:params})
//装置列表-详情
export const CaseTpInfo=(params)=>requests({url:'/caseTpInfo',method:'POST',data:params})
//对外交流
export const Exchange=(params)=>requests({url:'/exchange',method:'POST',data:params})
//对外交流-详情
export const ExchangeInfo=(params)=>requests({url:'/exchangeInfo',method:'POST',data:params})
//涉外项目
export const Pj=(params)=>requests({url:'/pj',method:'POST',data:params})
//涉外项目-详情
export const PjInfo=(params)=>requests({url:'/pjInfo',method:'POST',data:params})
//涉外项目-其他
export const OtherPj=(params)=>requests({url:'/OtherPj',method:'POST',data:params})
//社会荣誉
export const Honor=(params)=>requests({url:'/honor',method:'POST',data:params})
//社会荣誉-详情
export const HonorInfo=(params)=>requests({url:'/honorInfo',method:'POST',data:params}) 
//获奖项目
export const Performance=(params)=>requests({url:'/performance',method:'POST',data:params}) 
//获奖项目-详情
export const PerformanceInfo=(params)=>requests({url:'/performanceInfo',method:'POST',data:params})
//联系我们
export const Main=(params)=>requests({url:'/main',method:'POST',data:params})
//友情链接
export const Link=(params)=>requests({url:'/link',method:'POST',data:params})
//员工分类
export const MemberCt=(params)=>requests({url:'/memberCt',method:'POST',data:params})
//员工列表
export const Member=(params)=>requests({url:'/member',method:'POST',data:params})
//员工详情
export const MemberInfo=(params)=>requests({url:'/memberInfo',method:'POST',data:params})   
//员工详情
export const Stylist=(params)=>requests({url:'/stylist',method:'POST',data:params})   

